import utils from '../../shared/utils';

export const associatedServicesSelector = state => {
  const { id } = utils.getParameters().business;
  return state.admin.resources.business.data[id].services || [];
};
